import React, { FC, useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import styles from './playDialogButton.module.css';

interface PlayDialogI {
	helloText: string;
	lsMessage: string;
	voice: string;
	goodbyeText: string;
	meterMessage: string;
	infoMessage: string;
}

const PlayDialogButton: FC<PlayDialogI> = ({
	helloText,
	lsMessage,
	voice,
	goodbyeText,
	meterMessage,
	infoMessage
}) => {
	const [vocals, setVocals] = useState<string>();
	const [play, setPlay] = useState<boolean>(false);
	const [audioFiles, setAudio] = useState<string[]>([]);
	const myAudio = useRef(null);

	const initAudio = () => {
		setAudio([
			`https://tts.voicetech.yandex.net/tts?speaker=${voice}&lang=ru_RU&text=${helloText}`,
			`https://tts.voicetech.yandex.net/tts?speaker=${voice}&lang=ru_RU&text=${lsMessage}`,
			'./audio/номер_счета.wav',
			'./audio/Сигнал_получения_данных.wav',
			`https://tts.voicetech.yandex.net/tts?speaker=${voice}&lang=ru_RU&text=Вы ввели 1 1 1 0 4 2. Ожидайте идет проверка данных`,
			`https://tts.voicetech.yandex.net/tts?speaker=${voice}&lang=ru_RU&text=По Вашему лицевому счёту зарегистрирован 1 прибор учета:холодная вода. Текущие показания счетчика:0`,
			'./audio/Звуковой_сигнал.wav',
			'./audio/показания_счетчика.wav',
			'./audio/Сигнал_получения_данных.wav',
			`https://tts.voicetech.yandex.net/tts?speaker=${voice}&lang=ru_RU&text=Вы ввели 45. Если верно, скажите да`,
			'./audio/да.wav',
			`https://tts.voicetech.yandex.net/tts?speaker=${voice}&lang=ru_RU&text=${goodbyeText}`,
		]);
		setVocals('');
		setPlay(false);
	};

	const handleClick = async () => {
		if (!vocals || vocals === audioFiles[11]) setVocals(audioFiles[0]);
		play ? setPlay(false) : setPlay(true);
		if (myAudio.current !== null) {
			// @ts-ignore
			play ? myAudio!.current.pause() : myAudio!.current.load();
		}
		if (myAudio.current !== null && play) {
			// @ts-ignore
			initAudio();
		}
		// @ts-ignore
		myAudio!.current.addEventListener('ended', () => {
			audioFiles.shift();
			if (audioFiles.length > 0) {
				setVocals(audioFiles[0]);
				setPlay(true);
			} else {
				initAudio();
				return setPlay(false);
			}
		});
	};

	useEffect(() => {
		// setVocals('');
		initAudio();
	}, [helloText, lsMessage, voice, goodbyeText]);

	return (
		<>
			{
				<Button
					variant="outlined"
					className={styles.button}
					onClick={handleClick}
					disabled = {!helloText.trim() || !lsMessage.trim() || !goodbyeText.trim() || !meterMessage.trim() || !infoMessage.trim()}
				>
					{play ? 'Stop' : 'Play'}
				</Button>
			}
			<audio autoPlay ref={myAudio} className={styles.audio} src={vocals} />
		</>
	);
};

export default PlayDialogButton;
